<template>
  <div id="professional-reviews" v-on:scroll.passive='onScroll'>
    <div class="experience-average-rating" v-if="professional.status === 1 && (professionalReviews && professionalReviews.length > 0)">
      <i class="fas fa-star -rating-star mr-0"></i> {{ Number(professional.rating).toFixed(1) }}
      ({{ professional.rating_qty }} {{ $tc('message.professional.review', professional.rating_qty) }})
    </div>
    <div class="row">
      <div class="col-12 mt-3 p-0">
        <template v-if="professionalReviews && professionalReviews.length > 0">
          <professional-reviews
            :professional="professional"
            :professionalReviews="professionalReviews"
            @changedDisplayType="onChangeDisplayType"/>
          <div class="text-center">
            <a href=""
               class="btn btn-outline-info"
               :disabled="state.isFetching"
               @click.prevent="loadMoreReviews"
               v-if="state.isMore">
              {{ $t(isLoadMore) }}
            </a>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ProfessionalReviews from '../../review/ProfessionalReviews'
  import userEventLogHelpers from '../../../helpers/userEventLogHelpers'

  export default {
    components: {
      ProfessionalReviews
    },
    data () {
      return {
        queryData: {
          page: 0,
          limit: 5,
          professional_id: 0,
          user_id: 0,
          display_type: 'original'
        }
      }
    },
    computed: {
      ...mapGetters({
        isLoadMore: 'professionalReviews/isLoadMore',
        professional: 'professional/getProfessional',
        professionalReviews: 'professionalReviews/getProfessionalReviews',
        state: 'professionalReviews/getState',
        user: 'auth/getUser'
      })
    },
    methods: {
      loadMoreReviews () {
        this.queryData.page++
        this.$store.dispatch('professionalReviews/LOAD_PROFESSIONAL_REVIEWS', this.queryData)
      },
      onChangeDisplayType (displayType) {
        this.queryData.display_type = displayType
        this.queryData.page = 0
        this.queryData.limit = 5
        this.$store.dispatch('professionalReviews/SET_PROFESSIONAL_REVIEWS', null)
        this.$store.dispatch('professionalReviews/LOAD_PROFESSIONAL_REVIEWS', this.queryData)
      },
      onScroll () {
        console.log('check scroll')
      },
      loadFirstReviews () {
        // Clear professional reviews
        this.$store.commit('professionalReviews/SET_PROFESSIONAL_REVIEWS', null)
        // Fetch professional reviews
        this.queryData.page = 0
        this.queryData.professional_id = this.professional.id
        if (this.user) {
          this.queryData.user_id = this.user.id
        }
        this.$store.dispatch('professionalReviews/LOAD_PROFESSIONAL_REVIEWS', this.queryData)
      }
    },
    mounted () {
      // Fetch professional reviews
      if (this.professional) {
        this.loadFirstReviews()
      }
      // Save user event log
      userEventLogHelpers.logEvent('view_review_list', {
        professional_id: this.queryData.professional_id
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/professional/components/CleanerReviewsSection.vue